import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import SamlMetadataUploadForm from '../../components/saml/SamlMetadataUploadForm'
import { HeaderNavi } from '../../components/navigation'
import { HOSTNAME } from '../../constants/Constants'
import { UNAUTHORIZED } from '../../constants/Paths'
import isAdminUser from '../../helpers/isAdminUser'
import { useAppSelector } from '../../hooks'
import './SamlSetup.css'

/**
 * Entra連携用の隠し画面。既存のナビゲーションからは辿れず、
 * チーム管理者のみがURL直打ちでアクセスできる。
 */
const SamlSetupPage = () => {
  const user = useAppSelector((state) => state.user.user)
  const team = useAppSelector((state) => state.team)
  const defaultTeamDomain = HOSTNAME?.split('.')[0] ?? ''

  useEffect(() => {
    // 隠し画面のURLを検索エンジンにインデックスさせない
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)

    return () => {
      document.head.removeChild(meta)
    }
  }, [])

  if (!user) return null
  if (!isAdminUser(user)) return <Redirect to={UNAUTHORIZED} />

  return (
    <>
      <HeaderNavi />
      <main className="saml-setup-page" data-testid="saml-setup-page">
        <div className="saml-setup-page__container">
          <header className="saml-setup-page__header">
            <h1>SAML（Entra）設定</h1>
          </header>
          <div className="saml-setup-page__summary">
            <p className="saml-setup-page__description">
              Entraのフェデレーションメタデータをアップロードして、
              チームのSAML設定を登録・更新します。管理者専用の内部画面です。
            </p>
            {team.name && (
              <p className="saml-setup-page__team">{`対象チーム: ${team.name}`}</p>
            )}
          </div>
          <section className="saml-setup-page__form">
            <SamlMetadataUploadForm defaultTeamDomain={defaultTeamDomain} />
          </section>
        </div>
      </main>
    </>
  )
}

export default SamlSetupPage
